/**
 * Global app object holds all functions and app state
 */
var app = app || {};



/**
 * Initialisation functions
 */
app.init = {
  //application entry point, called at end of this file
  bootstrap: function () {

    // DataTable parameters for node tables
    app.tableDefaults = {
      scrollY: '400px',
      scrollX: false,
      scrollCollapse: true,
      info: false,
      bFilter: false,
      paging: false,
      deferRender: true,
      language: {
        processing: 'Loading...'
      },
      initComplete: function(table) {
        // tables can get out of alignment if window scrollbar appears, so force a readjustment after initialisation
        setTimeout(function () {
          table.oInstance.api(true).columns.adjust();
        }, 10);

        // refresh the column alignment when the tab changes
        $('#tab-company-db').on('toggled', function () {
          table.oInstance.api(true).columns.adjust();
        })
      }
    };

    //run conditional init functions if selector exists on page
    for (var selector in app.init.selectors) {
      var $item = $(selector);
      if ($item.length) app.init.selectors[selector]($item);
    }

    if (typeof searchAjaxUrl != 'undefined') {
      app.search.initialRequest(searchAjaxUrl);
    }

    app.thumbnail.init();
    app.viewCount.update();
  },

  dismiss: function (selector) {
    //find dismiss button in selected element and click it
    $(selector).find('.dismiss').click();
  },

  //selector-based init functions, called from bootstrap
  selectors: {

    '#document-companies-house': function ($section) {
      var $table = $section.find('#mentions-table');
      $table.DataTable($.extend({
        "order": [[2, "desc"]]
      }, app.tableDefaults));
    },
    '.exactMatches': function($section) {
      // There were issues with the data tables loading.
      // This makes them load before they are displayed.
      $section.css("visibility", "visible");
    },
    '#document-viewer': function () {
      app.documentviewer.init();
    },
    'form.find-in-document': function ($form) {
      $form.on('submit', function (event) {
        event.preventDefault();
        var form = $(event.target);
        var term = form.find('input[name="q"]').val();
        app.highlight.findInDocument(term);
      });
      $form.trigger('submit');
    },


    'a[href*="surveymonkey"]': function ($link) {
      $link.attr('target', '_blank');
      $link.on('click', function (event) {
        var $surveyMonkey = $('#surveyMonkeyInfo');
        if ($surveyMonkey.is('*') && $(window).width() > 510) {
          event.preventDefault();
          $surveyMonkey.show().parent('.popup-container').show();
        }
      });
    },
    '#more-button': function ($moreButtonContainer) {
      // trigger a button click when the button scrolls into view
      $(window).scroll(function () {
        if ($moreButtonContainer.offset().top < $(window).scrollTop() + $(window).height()) {
          var $more = $moreButtonContainer.find('.more');
          $more.click();
        }
      });

      // fire off an ajax request, and show the loading icon when the button is clicked
      $moreButtonContainer.on('click', '.more', function (event) {
        event.preventDefault();
        if ($(this).attr('href')) {
          var url = $(this).attr('href');

          $moreButtonContainer.find('a')
            .text('Loading more results...')
            .attr('href', '')
            .addClass('loading');

          app.search.nextPage(url);
        }
      });
    },
    // When clicking on an item in the 'references in this document' column
    '.in-doc-mentions': function ($el) {
      $el.on('click', function (event) {
        event.preventDefault();
        var term = event.target.getAttribute('data-search');
        app.highlight.findInDocument(term);
        $('#find-in-doc input').attr("value", term);
      });
    },
    '.show-button': function ($el) {
      $el.on('click', function (event) {

        var targetTable = $('.' + $(this).attr('data-target'));
        var icon = $(this).find('.fa');
        var label = $(this).find('.show-button-label');

        targetTable.toggleClass('hide-table');

        if (label.html() == 'Show') {
          label.html('Hide')
        } else {
          label.html('Show')
        }

        if (icon.hasClass('fa-angle-down')) {
          icon.removeClass('fa-angle-down')
          icon.addClass('fa-angle-up')
        } else {
          icon.removeClass('fa-angle-up')
          icon.addClass('fa-angle-down')
        }

      })
    },
    '.person-role-dropdown-button': function($el) {
      $el.on('click', function (event) {

        event.preventDefault();

        var target = $('#' + $(this).attr('data-target'));
        var icon = $(this).find('.fa');

        target.toggleClass('hide-table');

        if (icon.hasClass('fa-angle-down')) {
          icon.removeClass('fa-angle-down')
          icon.addClass('fa-angle-up')
        } else {
          icon.removeClass('fa-angle-up')
          icon.addClass('fa-angle-down')
        }
      })
    },
    '#address-search-form': function($form) {
      $form.on('submit', function(e) {
        e.preventDefault()
        $form.find('button').text('Search again')
        app.searchAddresses.begin($form.attr('action'), $form.serialize())
      })
    },
    '#address-search-results': function($items) {
      $items.on('click', '.address-search-item', function(e) {
        e.preventDefault()
        const $form = $('#address-search-form')
        $form.find('input[name=q]').val($(this).text())
        $form.submit()
      })
    }
  }
};

app.similarNames = {
  init: function () {
    // Use search box to filter table
    $('#similar-names-filter').on('keyup', function () {
      app.similarNamesTable.search(this.value).draw();
    });

    $('.similar-names-content').on('click', '.search-results-checkbox, .similar-names-selected-item', function () {
      app.similarNames.updateSearch($(this).data('row'))
    })

    // ensure any similar names that were in the query are selected
    app.similarNamesData.forEach(function (data, row) {
      if (app.similarNames.indexInNormalisedArray(data.name, app.initialQueryNames) > -1) {
        app.similarNames.updateSearch(row);
      }
    });
  },

  removeFirst: function (array, item) {
    for (var i = 0; i < array.length; i++) {
      if (array[i] === item) {
        array.splice(i, 1);
        return true;
      }
    }
    return false;
  },

  createSelectedItem: function (name, row) {
    var $item = $('<div><span class="cross">&times;</span> ' + name + '</div>')
      .addClass('similar-names-selected-item')
      .attr('data-row', row)
      .on('click', function () {
        app.similarNames.updateSearch(row);
      });
    $('.similar-names-selected-list').append($item);
    $('.similar-names-none-selected').removeClass('show');
  },

  updateSearch: function (row) {
    var name = app.similarNamesData[row].name;
    var index = this.getQueryNameIndex(name);
    if (index >= 0) {
      this.removeFirst(app.queryNames, app.queryNames[index]);
      $('.similar-names-selected-item[data-row="' + row + '"]').remove();
      if ($('.similar-names-selected-item').length === 0) {
        $('.similar-names-none-selected').addClass('show');
      }
    } else {
      app.queryNames.push(name);
      this.createSelectedItem(name, row);
    }

    function quoteName (name) {
      return '"' + name + '"';
    }
    var queryString = app.queryNames.map(quoteName).join(' OR ');

    $('.search-query').val(queryString);
    $('.similar-names-show-more-button').prop('disabled', false);
    // Ensure checkbox is redrawn
    app.similarNamesTable.rows(row).invalidate();
  },

  sortTable: function (selectedIndex) {
    app.similarNamesTable.order([selectedIndex, 'asc']).draw();
  },

  // This should mirror the behaviour of Matching::normaliseName()
  normaliseName: function (name) {
    return name.toLowerCase().replace(/[^\w]+/g, ' ').trim();
  },

  isQueryName: function (name) {
    return this.getQueryNameIndex(name) !== -1;
  },

  getQueryNameIndex: function (name) {
    return this.indexInNormalisedArray(name, app.queryNames);
  },

  indexInNormalisedArray: function (name, array) {
    return array.map(this.normaliseName).indexOf(this.normaliseName(name));
  }
};

app.search = {
  initialRequest: function (url) {
    $('#no-results-title').removeClass('show');
    $('.search-page-disclaimer').removeClass('show');
    $('.Loader').addClass('show');
    // var d = new Date();
    // var searchStartTime = d.getTime();
    // console.log('Start search with ' + url);
    $.get(url)
      .then(function (data) {
        // var d = new Date();
        // var searchEndTime = d.getTime();
        // console.log('Search complete in ' + (searchEndTime - searchStartTime) + ' milliseconds');
        var $search = $('#search-right').find('.search-ajax');
        var $newSearch = $(data).find('#search-right');
        $('#tab-title-investigative-reports').text('Investigative Reports (' + ($newSearch.data('results') || 0) + ')');

        var $header = $search.find('header');
        var $newHeader = $newSearch.find('header');

        $search.find('#search-title').replaceWith($newSearch.find('#search-title'));

        var relatedSearchesId = '#related-searches';
        var relatedSearches = $newHeader.find(relatedSearchesId);
        if (relatedSearches.length > 0) {
          console.log(relatedSearches.length);
          console.log($search.find(relatedSearchesId));
          $search.find(relatedSearchesId).replaceWith(relatedSearches);
        }

        var $newItems = $newSearch.find('.items').children();
        if ($newItems.length > 0) {
          $('.search-page-disclaimer').addClass('show');
          $search.find('#search-title').show();
          $search.find('.items')
            .removeClass('empty')
            .append($newItems);
        } else {
          $('#no-results-title').addClass('show');
          $search.find('#search-title').hide();
        }

        var $moreButton = $search.find('#more-button');
        var $newMoreButton = $newSearch.find('#more-button');
        if ($newMoreButton.length > 0) {
          $moreButton.html($newMoreButton.html());
        } else {
          $moreButton.remove();
        }

        app.foundation.equalize();
        $('.Loader').removeClass('show');

      })
      .then(function () {
        app.search.autoLoadMore();
      });
  },
  nextPage: function (url) {
    $.get(url, function (data) {
      var $dom = $(data);
      var $items = $('#search-right').find('.items');
      $items.append($dom.find('#search-right .items').contents());
      $('#more-button').empty().append($dom.find('#more-button .more'));

      app.foundation.equalize();
    }).then(function () {
      app.search.autoLoadMore();
    });
  },
  autoLoadMore: function () {

    // This function triggers a more button click, which triggers nextPage
    // It is being used to automatically trigger more ajax requests on page load
    // This is so search is broken up into chunks, meaning some results are displayed more quickly

    var total = app.search.updateTotal();
    // Autoload turns off after this max. It doesn't stop the more button working.
    var max = 60;

    var moreButton = $('#more-button').find('.more');
    var url = moreButton.attr('href');

    if (url && (total < max)) {
      // $('.more-results').text('. Scroll down for more...');
      moreButton.click();
    } else if (!url) {
      // $('.more-results').text('');
    }
  },
  updateTotal: function () {
    var numResults = $('.num-results.displayed');
    var newTotal = $('.search-result').length;
    numResults.text(newTotal);
    return newTotal;
  }
};

//$(document).foundation('reveal', {animation: 'none'});

app.foundation = {
  equalize: function () {
    $(document).foundation({
      equalizer: {
        equalize_on_stack: true
      }
    });
  }
}

app.thumbnail = {
  state: {
    waypoints: []
  },
  init: function () {
    app.thumbnail.state.waypoints = $('.page-text').waypoint({
      handler: function (direction) {
        var pageNumber = $(this.element).data('page');
        app.thumbnail.showPage(pageNumber);
      }
    });

  },
  disable: function () {
    app.thumbnail.state.waypoints.forEach(function (wp) {
      wp.disable();
    });
  },
  enable: function () {
    if (app.thumbnail.state.waypoints.length == 0) {
      app.thumbnail.init();
    }
    app.thumbnail.state.waypoints.forEach(function (wp) {
      wp.enable();
    });
    app.thumbnail.showPage(1);
  },
  showPage: function (pageNumber) {
    $('.document-view .thumbnail-container')
      .find('a').hide()
      .end()
      .find('a[data-page="' + pageNumber + '"]').show();
  }
}

app.viewCount = {
  update: function () {
    var viewCount = $('#view-count');
    if (viewCount.length > 0) {
      var url = viewCount.data('url');

      $.post(url).done(function (data) {
        $('#view-count').text(data.count);
      });
    }
  }
}

app.highlight = {

  // Second parameter basically just tells _populateResults that a search has been performed
  // This function is run when even when there is no search, due to the way the app has been built
  // In such cases - when there is no search phrase(s) - we want to be able to hide the 'Results: 0 matches' text
  _populateResults: function (pages, search) {

    var snippetLength = 30; //the length of the snippet on each side of the word

    var highlights = pages.find('.snippet');

    var results = $('.in-document-results');
    var lastPage = 0;

    var resultsMessage = highlights.length + " matches";
    if (highlights.length === 1) {
      resultsMessage = highlights.length + " match";
    }
    $('.in-document-results-count').text(resultsMessage)

    // If search is empty, will remove the '0 results' message
    // (Obviously we want to be showing that there are 0 results when
    // the search isn't empty)
    if (search) {
      $('.in-doc-results-header').removeClass('hidden')
    } else {
      $('.in-doc-results-header').addClass('hidden')
    }

    results.each(function () {
      var current = $(this);

      highlights.each(function () {
        //add page number to search results list
        var page = parseInt($(this).closest('.page-text').data('page'));
        if (page !== lastPage) {
          current.append('<li class="page-no"><h3>Page ' + page + '</h3></li>');
          lastPage = page;
        }

        var result = $(this).clone();

        var next = this.nextSibling;
        var prev = this.previousSibling;

        prev = prev.splitText(Math.max(prev.length - snippetLength, 0));
        next.splitText(Math.min(snippetLength, next.length))

        var id = result.attr('id');
        result
          .attr('id', '')
          .appendTo(current)
          .wrap('<li><a class="checkbox in-document-link" href="#' + id + '"></a></li>');

        var span = result.parent('a');

        if (next.length) {
          span.append(next.data.replace(/\s+$/g, '') + '...');
        }

        if (prev.length) {
          span.prepend('...' + prev.data.replace(/^\s+/g, ''));
        }
      });
    });


    $('.top-off-canvas-menu .in-document-results .in-document-link').on('click', function () {
      $('.off-canvas-wrap').foundation('offcanvas', 'toggle', 'move-bottom');
    });
  },
  findInDocument: function (searchTerms) {
    const pages = $('.page-text');

    // Clear results of previous search, if any
    pages.find('.snippet').each(function (index) {
      $(this).removeClass('snippet').attr('id', '');
    });
    $('.in-document-results').empty();
    $('.in-doc-results-header').addClass('hidden')

    // searchTerms must be either an array or string, which will converted to an array
    var searchTermsArray = searchTerms;
    if (typeof (searchTerms) === 'string') {
      searchTermsArray = searchTerms.split(" OR ");
    }

    // Convert each search term to a regex that will match the same variants as the Postgres mentions search, allowing
    // variants such as Ltd vs Limited. The regex must produce the same number of matches as the substr_count() in
    // documentMentions.php.
    searchTermsArray = searchTermsArray.map(function (term) {
      term = term.toUpperCase();
      term = term.replace(/[^\w ]/g, ' ');
      term = term.replace(/  +/g, ' ').trim();
      term = term.replace(/\b(LTD|LIMITED)\b/g, '\\b(LTD|LIMITED)\\b');
      term = term.replace(/\b(PTY|PROPRIETARY)\b/g, '\\b(PTY|PROPRIETARY)\\b');
      // If one variant is a prefix of the other, specify the long variant first so we match it greedily
      term = term.replace(/\b(CORPORATION|CORP)\b/g, '\\b(CORPORATION|CORP)\\b');
      term = term.replace(/\b(INCORPORATED|INC)\b/g, '\\b(INCORPORATED|INC)\\b');
      term = term.replace(/\b(COMPANY|CO)\b/g, '\\b(COMPANY|CO)\\b');
      return term.replace(/ /g, '[^\\w]*');
    });

    const giantRegex = new RegExp('(' + searchTermsArray.join('|') + ')', 'i');
    // Remove any current highlights
    pages.unmark({
      element: 'span',
      className: 'highlight',
      // When we're done removing highlights, highlight matches for the regex
      done: function () {
        var matchedText = '';
        var snippetCount = 0;
        pages.markRegExp(giantRegex, {
          element: 'span',
          className: 'highlight',
          acrossElements: true,
          // mark.js passes each highlighted element to the each() function. If a term is matched across elements
          // (eg a break tag), there will be more than one highlighted element for the match. We need to reassemble
          // the matched text so we can count the number of matches (rather than the number of highlighted elements)
          // and assign a snippet ID to the first highlighted element of each match
          each: function (elem) {
            if (!matchedText && giantRegex.test(elem.innerHTML)) {
              // First match, which may have more elements
              matchedText = elem.innerHTML;
              $(elem).addClass('snippet').attr('id', 'snippet-' + snippetCount++);
            } else if (matchedText && giantRegex.test(matchedText + ' ' + elem.innerHTML)) {
              // Is this a continuation of the current match or the start of a new match?
              if ((matchedText + ' ' + elem.innerHTML).replace(giantRegex, '')) {
                // Start of a new match
                matchedText = elem.innerHTML;
                $(elem).addClass('snippet').attr('id', 'snippet-' + snippetCount++);
              } else {
                // Continuation of the current match, which may have more elements
                matchedText += ' ' + elem.innerHTML;
              }
            } else if (matchedText) {
              // Continuation of the current match, which is not yet complete
              matchedText += ' ' + elem.innerHTML;
            } else {
              // First element of the first match, which is not yet complete
              matchedText = elem.innerHTML;
              $(elem).addClass('snippet').attr('id', 'snippet-' + snippetCount++);
            }
          },
          // When we're done highlighting, show the search results
          done: function () {
            app.highlight._populateResults(pages, searchTerms);
          }
        });
      }
    });
  }
}

app.cookie = {
  set: function (name, value, expireDays) {
    var expires = new Date();
    expires.setDate(expires.getDate() + expireDays);
    document.cookie = name + '=' + encodeURIComponent(value) + ';path=/'
      + ((expireDays == null) ? "" : ";expires=" + expires.toUTCString());
  },
  get: function (name) {
    var i, x, y, cookies = document.cookie.split(";");
    for (i = 0; i < cookies.length; i++) {
      var bits = cookies[i].split('=');
      if ($.trim(bits[0]) == name) {
        return bits[1] ? decodeURIComponent(bits[1]) : '';
      }
    }
    return '';
  }
};

app.documentviewer = {
  state: {
    on: false,
    viewer: null,
    switch: null
  },
  init: function () {
    app.documentviewer.state.viewer = $('#document-viewer');
    app.documentviewer.state.switch = $('#document-viewer-switch');

    app.documentviewer.state.switch.on('change', function () {
      app.documentviewer.updateViewer();
    });

    if (Cookies.get('pngi-document-viewer-off') == undefined) {
      app.documentviewer.state.on = true;
      app.documentviewer.getViewer();
      app.documentviewer.state.switch.prop('checked', true);
    }
  },
  updateViewer: function () {
    app.documentviewer.state.on = !app.documentviewer.state.on;
    console.log("document viewer is ", app.documentviewer.state.on);
    if (app.documentviewer.state.on) {
      Cookies.remove('pngi-document-viewer-off', {expires: 365});
      console.log("Remove cookie", Cookies.get('pngi-document-viewer-off'));
      app.documentviewer.getViewer();
    } else {
      Cookies.set('pngi-document-viewer-off', '1', {expires: 365});
      console.log("Set cookie", Cookies.get('pngi-document-viewer-off'));
      app.documentviewer.removeViewer();
    }
  },
  removeViewer: function () {
    var $viewer = app.documentviewer.state.viewer;
    $viewer.find('.document-view').empty();
    app.thumbnail.disable();
  },
  getViewer: function () {
    var $viewer = app.documentviewer.state.viewer;
    var url = $viewer.data('link');

    $.get(url).then(function (data) {
      $viewer.find('.document-view').replaceWith(data);
      app.thumbnail.enable();
    });
  }
}

app.searchAddresses = {
  dataTable: null,
  $root: null,
  begin: function(url, data) {
    if (app.searchAddresses.dataTable) {
      app.searchAddresses.dataTable.clear().destroy()
    }

    if (!app.searchAddresses.$root) {
      app.searchAddresses.$root = $('#address-search-results')
    }

    columns= [
      {
        data: 'address',
        title: 'Address',
        searchable: false,
        render: function (data) {
          return '<a href="#" class="address-search-item">' + data + '</a>'
        }
      },
      {
        data: 'person_name',
        title: 'Used By',
        searchable: false,
        render: function (data) {
          return data ? app.util.makeSearchLink(data) : '&ndash;'
        }
      },
      {
        data: 'company_name',
        title: 'Company',
        searchable: false,
        render: function (data) {
          return data ? app.util.makeSearchLink(data) : '&ndash;'
        }
      }
    ]
    if (pnshow_source) {
        columns.push({
                data: 'data_source',
                title: 'Source',
                searchable: false,
                render: function (data) {
                  return data.charAt(0).toUpperCase() + data.substring(1);
                }
              })
    }

    const dataTableArgs = $.extend(app.tableDefaults, {
      paging: true,
      processing: true,
      serverSide: true,
      info: true,
      pageLength: 100,
      lengthChange: false,
      ajax: url + '?' + data.toString(),
      columns: columns
    })

    app.searchAddresses.$root.show()
    app.searchAddresses.$root.find('.enhanced-search-result').hide()
    app.searchAddresses.$root.find('.searching').show()
    app.searchAddresses.dataTable = app.searchAddresses.$root.find('.node-table-wrapper .search-results-table').DataTable(dataTableArgs)
    app.searchAddresses.dataTable.on('draw', function () {
      app.searchAddresses.$root.find('.searching').hide()
      const tableInfo = app.searchAddresses.dataTable.page.info()
      if (tableInfo.pages > 0) {
        app.searchAddresses.$root.find('.node-table-wrapper').show()
      } else {
        app.searchAddresses.$root.find('.no-results').show()
      }
    })
  }
}

app.util = {
  makeSearchLink: function (text, label, doc) {
    if (!label) {
      label = text
    }
    const args = { q: text, exact: 1 }
    if (doc) {
      args.doc = 1
    }
    const params = new URLSearchParams(args)
    return '<a href="/search?' + params.toString() + '">' + label + '</a>'
  }
}
//start it up
app.init.bootstrap();

function setSource(sel) {
  Cookies.set('ipasource', sel.options[sel.selectedIndex].value);
}